import React from 'react';
import { components } from 'react-select';
import './CustomDropdownContainer.css';

const MAX_VISIBLE_CHIPS = 1;

const getInputChild = (children) => {
  const childrenArray = React.Children.toArray(children);
  if (childrenArray.length === 0) return null;
  // react-select always renders Input / DummyInput as the last ValueContainer child
  return childrenArray[childrenArray.length - 1];
};

const focusSelectInput = (fromEl) => {
  const control = fromEl?.closest?.('.react-select__control, .multi-select');
  const inputEl = control?.querySelector?.('input');
  if (inputEl && typeof inputEl.focus === 'function') {
    inputEl.focus();
  }
};

export const CustomMultiOption = (props) => {
  const { isSelected, label } = props;
  return (
    <components.Option {...props}>
      <div className="custom-multi-option">
        <span
          className={`custom-multi-option__check${isSelected ? ' is-checked' : ''}`}
          aria-hidden="true"
        >
          {isSelected ? '✓' : ''}
        </span>
        <span className="custom-multi-option__label">{label}</span>
      </div>
    </components.Option>
  );
};

const CustomDropdownContainer = (props) => {
  const isMulti = !!props.selectProps?.isMulti;
  const isDisabled = !!props.selectProps?.isDisabled;

  // Single-select: keep default react-select rendering for consistent height/typography.
  if (!isMulti) {
    return (
      <components.ValueContainer {...props}>
        {props.children}
      </components.ValueContainer>
    );
  }

  const selected = props.getValue() || [];

  // Deduplicate by value so duplicate select values don't render twice
  const uniqueSelected = [];
  const seen = new Set();
  selected.forEach((val) => {
    if (!val || val.value == null) return;
    const key = String(val.value);
    if (seen.has(key)) return;
    seen.add(key);
    uniqueSelected.push(val);
  });

  const displayValues = uniqueSelected.slice(0, MAX_VISIBLE_CHIPS);
  const extraCount = uniqueSelected.length - MAX_VISIBLE_CHIPS;
  const input = getInputChild(props.children);

  const openMenuForEditing = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isDisabled) return;
    focusSelectInput(event.currentTarget);
  };

  return (
    <components.ValueContainer
      {...props}
      className={`${props.className || ''} custom-dropdown-value-container`.trim()}
    >
      {uniqueSelected.length === 0 ? (
        props.children
      ) : (
        <>
          <div className="custom-multi-tags">
            {displayValues.map((val) => (
              <div
                key={String(val.value)}
                className="custom-multi-tag"
                title={val.client_name || val.designation_name || val.label}
              >
                <span className="custom-multi-tag__label">
                  {val.client_name || val.designation_name || val.label}
                </span>
                {!isDisabled && (
                  <span
                    className="custom-multi-tag__remove"
                    role="button"
                    tabIndex={-1}
                    aria-label={`Remove ${val.label || 'selection'}`}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const newValue = selected.filter((s) => String(s.value) !== String(val.value));
                      props.setValue(newValue, 'remove-value');
                    }}
                  >
                    ×
                  </span>
                )}
              </div>
            ))}
            {extraCount > 0 && (
              <div
                className="custom-multi-tag-more"
                title={`${extraCount} more selected — click to manage`}
                role="button"
                tabIndex={-1}
                onMouseDown={openMenuForEditing}
              >
                +{extraCount} more
              </div>
            )}
          </div>
          <div className="custom-multi-input-slot">{input}</div>
        </>
      )}
    </components.ValueContainer>
  );
};

export default CustomDropdownContainer;
